import React, { useRef, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import MermaidDiagram from './MermaidDiagram';

const MarkdownView = ({ content, disabled, hasError, isPKSDetail }) => {
    // Use a ref-based counter that resets on each render cycle to generate
    // stable, unique IDs per mermaid block without leaking across instances
    const counterRef = useRef(0);
    counterRef.current = 0;

    const getContainerStyle = () => {
        if (hasError) return { borderColor: '#f44336' };
        if (isPKSDetail) return { border: 'none', borderRadius: '0px' };
        return undefined;
    };

    // Memoize components map so ReactMarkdown doesn't recreate it on every render
    const components = useMemo(() => ({
        table: ({ children }) => (
            <div className='md-table-wrapper'>
                <table>{children}</table>
            </div>
        ),
        iframe: () => {
            return null
        },
        code: ({ node, inline, className, children, ...props }) => {
            const language = /language-(\w+)/.exec(className || '')?.[1];
            const code = String(children).replace(/\n$/, '');
            if (!inline && language === 'mermaid') {
                counterRef.current += 1;
                return (
                    <MermaidDiagram
                        code={code}
                        id={`md-mermaid-${counterRef.current}`}
                        disabled={disabled}
                    />
                );
            }
            return (
                <code className={className} {...props}>
                    {children}
                </code>
            );
        },
    }), [disabled]);

    return (
        <div
            className={`markdown-render ${!content ? 'markdown-default' : ''} ${disabled && !isPKSDetail ? 'markdown-disabled' : ''}`}
            style={getContainerStyle()}
        >
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={components}
            >
                {content || ''}
            </ReactMarkdown>
        </div>
    );
};

export default MarkdownView;
